import React, { useState } from 'react';
import { Helmet } from 'react-helmet';
import { QueryClient, QueryClientProvider } from 'react-query';
import Logo from '../components/atoms/Logo';
import PageHead from '../components/base/PageHead';
import GetStartedForm from '../components/organisms/GetStartedForm';
import AttendzenLogo from '../images/Attendzen_Logo.png';
import HexabaseLogo from '../images/Hexabase_Logo.png';
import PostcallLogo from '../images/Postcall_Logo.png';
import SaltyDonutLogo from '../images/Salty_Donut_Logo.png';

const GetStarted = () => {
  const [success, setSuccess] = useState(false);

  return (
    <QueryClientProvider client={new QueryClient()}>
      <Helmet
        bodyAttributes={{
          class: 'font-sans text-base antialiased text-slate-700 bg-slate-50',
        }}
      />

      <main>
        <div className="flex flex-col items-center max-w-2xl py-8 mx-auto">
          <a
            href="/"
            target="_blank"
            rel="noopener noreferrer"
            tabIndex={-1}
            aria-label="Return to StackScout"
          >
            <Logo className="w-auto h-10" />
          </a>

          {success ? (
            <div className="flex flex-col items-center w-full px-8 py-12 mt-8 text-center bg-white border shadow-sm sm:rounded border-slate-50">
              <h1 className="mb-6 text-xl font-semibold">
                Glad to have you on board!
              </h1>

              <p className="max-w-md mx-auto text-slate-500">
                Your StackScout account is now ready. Click the button below to
                sign into your new StackScout account.
              </p>

              <div className="flex justify-center text-center">
                <a
                  href="https://app.stackscout.com"
                  className="inline-flex items-center justify-center w-full px-5 py-3 mt-4 text-sm font-medium text-white border border-transparent rounded-md bg-primary hover:bg-primary-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-500"
                >
                  Sign in to StackScout
                </a>
              </div>
            </div>
          ) : (
            <GetStartedForm onSuccess={() => setSuccess(true)} />
          )}
          <div className="text-center">
            <p className="mt-12 mb-2 text-sm tracking-wide text-slate-500">
              Trusted by freelancers, small and medium-sized businesses
            </p>
            <div className="grid grid-cols-2 gap-2 mx-auto w-80 md:gap-4 md:grid-cols-4 md:w-auto">
              <div className="flex items-center justify-center p-4">
                <img
                  src={PostcallLogo}
                  alt="Postcall"
                  className="w-full h-auto"
                />
              </div>

              <div className="flex items-center justify-center p-4">
                <img
                  src={AttendzenLogo}
                  alt="Attendzen"
                  className="w-full h-auto"
                />
              </div>

              <div className="flex items-center justify-center p-4">
                <img
                  src={SaltyDonutLogo}
                  alt="The Salty Donut"
                  className="w-full h-auto"
                />
              </div>

              <div className="flex items-center justify-center p-4">
                <img
                  src={HexabaseLogo}
                  alt="Hexabase"
                  className="w-full h-auto"
                />
              </div>
            </div>
          </div>
        </div>
      </main>
    </QueryClientProvider>
  );
};

export const Head = () => (
  <PageHead title="Sign up for StackScout" overrideTitleTemplate />
);

export default GetStarted;
